/*
 * Shared (app + Cloud Functions): recognising YouTube / X / Instagram posts.
 * Browser-only loaders live in src/feed/embeds.js.
 */
import { parseHost } from './links.js';

// Item type -> embed provider.
export const EMBED_TYPES = {
  youtube: 'youtube',
  tweet: 'twitter',
  instagram: 'instagram',
};

export const PROVIDER_NAMES = {
  youtube: 'YouTube',
  twitter: 'X',
  instagram: 'Instagram',
};

/** https URL -> { provider, id, url } or null when it isn't a supported post. */
export function parseEmbed(url) {
  const h = parseHost(url);
  if (!h) return null;
  const { u } = h;
  const path = u.pathname.split('/').filter(Boolean);

  if (h.host === 'youtube.com' || h.host === 'youtube-nocookie.com') {
    const id =
      u.searchParams.get('v') ||
      (['shorts', 'embed', 'live'].includes(path[0]) ? path[1] : null);
    if (id && /^[\w-]{11}$/.test(id)) return { provider: 'youtube', id, url };
  }
  if (h.host === 'youtu.be' && /^[\w-]{11}$/.test(path[0] || '')) {
    return { provider: 'youtube', id: path[0], url };
  }
  if (
    (h.host === 'twitter.com' || h.host === 'x.com') &&
    path[1] === 'status' &&
    /^\d{5,25}$/.test(path[2] || '')
  ) {
    return { provider: 'twitter', id: path[2], url };
  }
  if (
    h.host === 'instagram.com' &&
    ['p', 'reel', 'tv'].includes(path[0]) &&
    /^[\w-]{5,40}$/.test(path[1] || '')
  ) {
    return { provider: 'instagram', id: path[1], kind: path[0], url };
  }
  return null;
}

export const youtubeThumbnail = (id) =>
  `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

export const youtubeEmbedUrl = (id) =>
  `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;

export const instagramEmbedUrl = (id, kind = 'p') =>
  `https://www.instagram.com/${kind}/${id}/embed`;
